import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Leaf = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 4C17.921 4 13.149 5.975 9.562 9.562C5.975 13.149 4 17.921 4 23C4 25.757 6.243 28 9 28C14.079 28 18.851 26.025 22.438 22.438C26.025 18.851 28 14.079 28 9C28 6.243 25.757 4 23 4V4ZM21.95 20H13.414L17.414 16H24.491C23.831 17.454 22.972 18.798 21.95 20ZM12 10.05C13.202 9.028 14.546 8.169 16 7.509V14.586L12 18.586V10.05V10.05ZM19.414 14C19.414 14 24.004 9.41 25.707 7.707C25.895 8.099 26 8.537 26 9C26 10.739 25.737 12.418 25.249 14H19.414V14ZM24.293 6.293C22.502 8.084 18 12.586 18 12.586V6.751C19.581 6.263 21.261 6 23 6C23.463 6 23.901 6.105 24.293 6.293ZM6 23C6 18.836 7.506 15.018 10 12.059V20.586L6.293 24.293C6.105 23.901 6 23.463 6 23ZM7.707 25.707L11.414 22H19.941C16.982 24.494 13.164 26 9 26C8.537 26 8.099 25.895 7.707 25.707V25.707Z" />
	</svg>
);

export default Leaf;
